import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from '/src/components/modal/hooks/useModalHelper';
import Modal from '/src/components/modal/Modal';
import FormConversationFilter from './FormConversationFilter/FormConversationFilter';
import "./ConversationFilterModal.css"
const ConversationFilterModal = NiceModal.create(({ title, postbackAction, mode}) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    return (
        <Modal name={mode == 0 || mode == 1 ? "conversation_filter_modal_container" : "conversation_filter_relaunch_modal_container"} id={modal.id} autoClose="true" onClose={onClose} >
            <div className='leave-container'>
                <div className="button-leave" id="close_modal_container" onClick={onClose} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <FormConversationFilter title={title} onCloseModal={onClose} postbackAction={postbackAction} mode={mode} />

            {/*
                mode == 1 ?
                    //<FormRelaunchFilter title={title} onCloseModal={onClose} postbackAction={postbackAction}/>
                    <FormConversationFilter title={title} onCloseModal={onClose} postbackAction={postbackAction} mode={1} />
                    :
                    <FormConversationFilter title={title} onCloseModal={onClose} postbackAction={postbackAction} mode={0} />
*/
            }
        </Modal>
    );
});

export default ConversationFilterModal;